import { useEffect, useRef } from "react";
import { TProcessStates } from "../../lib/types/general";
import { Spinner } from "./spinner";

type TIncognitoModeProps = {
    onClickHandler: React.MouseEventHandler<HTMLButtonElement>;
    enabled: boolean;
    workingState: TProcessStates;
};
export const IncognitoButton = ({
    onClickHandler,
    enabled,
    workingState,
}: TIncognitoModeProps) => {
    const refIncognitoModal = useRef<HTMLDivElement>(null);
    const windowGlobal = window as any;
    const handleFirstModalShow = () => {
        const showModal1 = () => {
            if (!refIncognitoModal.current) {
                setTimeout(() => {
                    showModal1();
                }, 100);
                return;
            }

            windowGlobal.wwg_refIncognitoModal = new window.bootstrap.Modal(
                refIncognitoModal.current
            );

            if (windowGlobal.wwg_refIncognitoModal) {
                windowGlobal.wwg_refIncognitoModal.show();
            }
        };

        showModal1();
    };
    const handleFirstModalClose = () => {
        if (!refIncognitoModal.current) {
            setTimeout(() => {
                handleFirstModalClose();
            }, 100);
            return;
        }
        if (windowGlobal.wwg_refIncognitoModal) {
            //TODO: change to window.bootstrap.Modal.getInstance(refIncognitoModal.current)?.hide(); when we update to bootstrap 5.2
            windowGlobal.wwg_refIncognitoModal.hide();
        }
    };

    useEffect(() => {
        return () => {
            if (windowGlobal.wwg_refIncognitoModal) {
                windowGlobal.wwg_refIncognitoModal.hide();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <button
                type="button"
                className="btn btn-dark border border-light mt-2 px-4 d-flex align-items-center justify-content-between form-check form-switch flex-wrap"
                data-toggle="modal"
                onClick={handleFirstModalShow}
            >
                {workingState !== "done" ? (
                    <div className="my-lg-1" style={{ width: "14.3rem" }}>
                        <Spinner />
                    </div>
                ) : (
                    <>
                        <div className="d-flex align-items-center form-check-label">
                            {enabled ? (
                                <i className="fa-solid fa-eye-slash me-2"></i>
                            ) : (
                                <i className="fa-solid fa-eye me-2"></i>
                            )}{" "}
                            <span className=" fw-bold mb-0">
                                Incognito Mode
                            </span>
                        </div>
                        <input
                            className="form-check-input ms-2 my-0 my-lg-2"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckDefault"
                            checked={enabled}
                        />
                    </>
                )}
            </button>

            <div className="modal fade" tabIndex={-1} ref={refIncognitoModal}>
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-md-down">
                    <div className="modal-content bg-dark text-white p-3">
                        <div className="modal-header border-0 border">
                            <h1 className="modal-title fs-5">
                                {" "}
                                {enabled ? (
                                    <>
                                        <i className="fa-solid fa-eye me-3"></i>
                                    </>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-eye-slash me-3"></i>
                                    </>
                                )}
                                {enabled
                                    ? "Deactivate Incognito Mode"
                                    : "Activate Incognito Mode"}
                            </h1>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                // data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleFirstModalClose}
                            ></button>
                        </div>
                        <div className="modal-body ">
                            {enabled ? (
                                <>
                                    If you deactivate Incognito Mode, all your
                                    profile information will be visible to
                                    dental employers.
                                    <br /> <br />
                                    <strong>
                                        Are you sure you want to deactivate
                                        Incognito Mode?
                                    </strong>
                                </>
                            ) : (
                                <>
                                    <strong>
                                        You're About to Turn On Incognito Mode
                                    </strong>
                                    <br /> <br />
                                    When you activate incognito mode, here's
                                    what will happen:
                                    <br /> <br />
                                    <ul>
                                        {" "}
                                        <strong>
                                            {" "}
                                            <i className="fa-solid fa-circle-exclamation me-2"></i>
                                            Limited Profile Visibility:
                                        </strong>{" "}
                                        Only your skills and the personal
                                        profile section will remain visible to
                                        dental employers. These sections are
                                        highlighted in your profile, while
                                        everything darkened will be hidden.
                                    </ul>
                                    <ul>
                                        {" "}
                                        <strong>
                                            {" "}
                                            <i className="fa-solid fa-circle-exclamation me-2"></i>
                                            Exceptions for Dental Employers in
                                            Your Contact List:{" "}
                                        </strong>{" "}
                                        Dental employers in your contact list
                                        will continue to see your full profile.
                                    </ul>
                                    <ul>
                                        {" "}
                                        <strong>
                                            {" "}
                                            <i className="fa-solid fa-circle-exclamation me-2"></i>
                                            Anonymous Search and Matches:{" "}
                                        </strong>{" "}
                                        If a dental employer searches for you by
                                        name or sees you in match suggestions,
                                        you will appear as "Incognito Talent."
                                    </ul>
                                    <br />
                                    This mode gives you control over your
                                    privacy while staying visible for potential
                                    job opportunities.
                                    <br /> <br />
                                    <strong>
                                        Are you sure you want to activate
                                        Incognito Mode?
                                    </strong>
                                </>
                            )}
                        </div>
                        <div className="modal-footer border-0 border">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                // data-bs-dismiss="modal"
                                onClick={handleFirstModalClose}
                            >
                                {enabled
                                    ? "No, Stay Incognito"
                                    : "No, Stay Visible"}
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) => {
                                    onClickHandler(e);
                                    handleFirstModalClose();
                                }}
                                // data-bs-dismiss="modal"
                            >
                                {enabled
                                    ? "Yes, Show My Profile"
                                    : "Yes, Hide My Profile"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
